import { Component, HostBinding, computed } from '@angular/core';
import { AddressLabelComponent } from '../../address-label.component';

@Component({
  selector: 'street',
  standalone: true,
  template: `
    <span class="address-street-name">{{ streetName$$() }} </span> 
    <span class="address-street-number">{{ houseNumber$$() }}</span>
  `
})
export class StreetComponent extends AddressLabelComponent {
  @HostBinding('class.street-label')
  streetName$$ = computed<string>(() => this.addressFormat$$()?.streetName);
  houseNumber$$ = computed<number>(() => this.addressFormat$$()?.houseNumber);
}
